<div class="container">
  <div class="row" *ngIf="cotizacion>0 && conf">
    <div class="col-12 doble mb-4"></div>

    <div class="col-4">
      <h3 class="text-center">
        {{conf.name}}
      </h3>
      <p>
        <b><i class="fas fa-phone" aria-hidden="true"></i> Telefono: </b>{{conf.tel}}
      </p>
      <p>
        <b><i class="fas fa-map-marker" aria-hidden="true"></i> Dirección: </b>
        {{conf.dir}}
      </p>
    </div>
    <div class="col-4">
      <h1 class="text-center text-x">
        X
      </h1>
    </div>
    <div class="col-4">
      <h3 class="text-center">
        PROFORMA
      </h3>
      <h5>
        N° {{zfill(1,4) }}-{{zfill(item.id,8) }}
      </h5>
      <div class="row">
        <label for="" class="col-3 mt-2">
          Fecha:
        </label>
        <div class="datete col-2">
          {{item.created_at | date:'dd'}}
        </div>
        <div class="datete col-2">
          {{item.created_at | date:'MM'}}
        </div>
        <div class="datete col-2">
          {{item.created_at | date:'yy'}}
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 doble mb-4"></div>
      <div class="text-left">
        <p class="col-12 dotter">
          <b>Nombre:</b> {{item.cliente | uppercase }}
        </p>
        <p class="col-12 dotter">
          <b>Condición de pago:</b> {{item.condicion | uppercase}}
        </p>

        <div class="btn-group btn-group-toggle d-print-none" data-toggle="buttons">
          <label class="btn btn-secondary" [class.active]="item.condicion === 'contado'">
            <input type="radio" value="contado" (ngModelChange)="cambiarCondicionVenta($event)"
              [(ngModel)]="item.condicion" name="condicion" />
            Contado/transferencia
          </label>
          <!--
          <label class="btn btn-secondary" [class.active]="item.condicion === 'debito'">
            <input type="radio" value="debito" [(ngModel)]="item.condicion"
              (ngModelChange)="cambiarCondicionVenta($event)" name="condicion" /> Debito / Qr
          </label>
-->
          <label class="btn btn-secondary" [class.active]="item.condicion === 'tarjeta'">
            <input type="radio" value="tarjeta" [(ngModel)]="item.condicion"
              (ngModelChange)="cambiarCondicionVenta($event)" name="condicion" /> Tarjeta
          </label>
          &nbsp;
          <button class="btn btn-outline-primary" (click)="generarVenta()">
            <i class="fas fa-money"></i> Finalizar Compra
          </button>
        </div>

        <br>
        <br>
      </div>
    </div>
    <div class="col-12">
      <table class="table table-sm table-bordered  table-striped">
        <thead>
          <tr>
            <th class="col-1">Cantidad</th>
            <th class="col-6">Descripción</th>
            <th class="col-2">Precio/Unitario</th>
            <th class="text-right col-2">Sub Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <td>{{item.cantidad}}</td>
            <td class="align-middle">
              <app-image-preview [height]="'45px'" [width]="'45px'" [imgsrc]="item.mercaderia.thumb">
              </app-image-preview>
              [{{item.mercaderia.serie}}]
              {{item.mercaderia.nombre}}
            </td>
            <th class="align-middle text-right">{{ (item.precio * cotizacion) | currency:'ARS':'symbol':'1.2-2' }}</th>
            <th class="align-middle text-right">{{ (item.precio * item.cantidad * cotizacion) |
              currency:'ARS':'symbol':'1.2-2' }}
            </th>
            <th class="d-print-none">

              <div class="dropdown-item">
                <button (click)="dis(item)" class="btn btn-secondary btn-sm">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </button>
                &nbsp;
                <button (click)="add(item)" class="btn btn-secondary btn-sm">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
                &nbsp;
                <button (click)="del(item)" class="btn btn-danger btn-sm">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </div>
            </th>
          </tr>
          <tr>
            <td class="text-right" scope="row" colspan="2">
              <h4><b> Total</b></h4>
            </td>
            <td class="text-right" colspan="2">
              <label for="" style="font-size: 1.5em;">
                <b> {{ (item?.total * cotizacion) | currency:'ARS':'symbol':'1.2-2' }}</b>
              </label>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class="col-12 text-center">
      <label>
        Documento no valido como factura
      </label>
    </div>
  </div>
  <!-- Bloque visual de continuar compra -->
  <div class="d-print-none continuar-compra mt-4 text-center p-4 bg-light rounded-4 border border-1 border-opacity-25">
    <div class="mb-3">
      <i class="fa fa-shopping-bag fa-2x text-success mb-2"></i>
      <h5 class="mb-1 fw-semibold">¿Querés seguir explorando?</h5>
      <p class="text-muted mb-3 small">
        Descubrí más productos y completá tu compra con lo que te falta.
      </p>
      <a routerLink="/" class="btn btn-outline-success btn-lg rounded-pill px-4">
        <i class="fa fa-store me-2"></i> Seguir comprando
      </a>
    </div>
  </div>
</div>